<ng-container *ngIf="user">

  <!-- ── Avatar trigger ────────────────────────────────────────────────────── -->
  <div class="um-trigger" (click)="toggleDropdown($event)" [attr.aria-expanded]="isDropdownOpen">
    <div class="um-avatar">
      <span>{{ initials }}</span>
    </div>
  </div>

  <!-- ── Dropdown menu ─────────────────────────────────────────────────────── -->
  <div class="um-dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
    <!-- Email (non-interactive) -->
    <div class="um-dropdown__email">{{ user.email }}</div>

    <div class="um-dropdown__divider"></div>

    <!-- View Profile -->
    <button class="um-dropdown__item" type="button" (click)="openProfile()">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <circle cx="7.5" cy="5" r="2.5" stroke="currentColor" stroke-width="1.3"/>
        <path d="M2.5 13c0-2.76 2.24-5 5-5s5 2.24 5 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
      View Profile
    </button>

    <!-- Feedback (rating survey) -->
    <button class="um-dropdown__item" type="button" (click)="openFeedback()">
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M8 1.8l1.85 3.75 4.15.6-3 2.93.71 4.12L8 11.27l-3.71 1.95.71-4.12-3-2.93 4.15-.6L8 1.8z"
              stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Feedback
    </button>

    <!-- Log Bug (detailed defect report) -->
    <button class="um-dropdown__item" type="button" (click)="openLogBug()">
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M8 5.5a3 3 0 013 3v2a3 3 0 01-6 0v-2a3 3 0 013-3zM6 5l-.8-1.2M10 5l.8-1.2M5 8.5H2.5M11 8.5h2.5M5.2 11l-1.7 1.2M10.8 11l1.7 1.2"
              stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Log Bug
    </button>

    <!-- Sign out -->
    <button class="um-dropdown__item um-dropdown__item--danger" type="button" (click)="signOut()">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M5.5 2H3a1 1 0 00-1 1v9a1 1 0 001 1h2.5M10 10.5l3-3-3-3M13 7.5H6"
              stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Sign out
    </button>
  </div>

</ng-container>

<!-- ══ Profile Modal ══════════════════════════════════════════════════════════ -->
<ng-container *ngIf="isProfileOpen && user">
  <!-- Backdrop -->
  <div class="um-modal-backdrop" (click)="closeProfile()"></div>

  <!-- Dialog -->
  <div class="um-modal" role="dialog" aria-modal="true" aria-labelledby="um-modal-title">

    <!-- Header -->
    <div class="um-modal__header">
      <h3 class="um-modal__title" id="um-modal-title">Profile</h3>
      <button class="um-modal__close" type="button" (click)="closeProfile()" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- Identity strip -->
    <div class="um-modal__identity">
      <div class="um-modal__avatar">
        <span>{{ initials }}</span>
      </div>
      <div>
        <p class="um-modal__identity-name">{{ user.name }}</p>
        <p class="um-modal__identity-email">{{ user.email }}</p>
      </div>
    </div>

    <div class="um-modal__divider"></div>

    <!-- Fields (all from UM check-auth) -->
    <div class="um-modal__fields">
      <div class="um-field">
        <label class="um-field__label">Full Name</label>
        <div class="um-field__value">{{ user.name || '—' }}</div>
      </div>
      <div class="um-field">
        <label class="um-field__label">Email</label>
        <div class="um-field__value">{{ user.email || '—' }}</div>
      </div>
      <div class="um-field">
        <label class="um-field__label">Department</label>
        <div class="um-field__value">{{ user.displayDepartment || '—' }}</div>
      </div>
    </div>

    <!-- Note -->
    <p class="um-modal__note">
      <svg width="13" height="13" viewBox="0 0 14 14" fill="none" style="flex-shrink:0;margin-top:1px">
        <circle cx="7" cy="7" r="6" stroke="#9ca3af" stroke-width="1.2"/>
        <path d="M7 5v3.5M7 10v.2" stroke="#9ca3af" stroke-width="1.2" stroke-linecap="round"/>
      </svg>
      Profile details are managed by your administrator and cannot be changed here.
    </p>

    <!-- Footer -->
    <div class="um-modal__footer">
      <button class="um-modal__close-btn" type="button" (click)="closeProfile()">Close</button>
    </div>

  </div>
</ng-container>
